import axios from "../axios";

export async function fetchCommuncations(payload) {
  const customer = payload?.customer_id;
  return axios({
    method: "get",
    url: "/customers/" + customer + "/communications",
    params: payload,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function fetchCommuncation(payload) {
  const customer = payload?.customer_id;
  return axios.get(`/customers/${customer}/communications/${payload.id}`);
}
